// ===================================
// PROMPT API SERVICE
// src/services/promptApi.js
// Frontend API calls for prompts
// ===================================

import api from './api';

/**
 * Get available prompt types
 */
export const getPromptTypes = async () => {
  const response = await api.get('/prompts/types');
  return response.data;
};

/**
 * Preview a built prompt
 */
export const previewPrompt = async (config) => {
  const response = await api.post('/prompts/preview', config);
  return response.data;
};

/**
 * List all prompts (admin)
 */
export const getPrompts = async (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  const response = await api.get(`/prompts/admin?${params.toString()}`);
  return response.data;
};

/**
 * Get single prompt by ID (admin)
 */
export const getPrompt = async (id) => {
  const response = await api.get(`/prompts/admin/${id}`);
  return response.data;
};

/**
 * Create a new prompt (admin)
 */
export const createPrompt = async (promptData) => {
  const response = await api.post('/prompts/admin', promptData);
  return response.data;
};

/**
 * Update a prompt (admin)
 */
export const updatePrompt = async (id, promptData) => {
  const response = await api.put(`/prompts/admin/${id}`, promptData);
  return response.data;
};

/**
 * Delete a prompt (admin)
 */
export const deletePrompt = async (id, hard = false) => {
  const response = await api.delete(`/prompts/admin/${id}?hard=${hard}`);
  return response.data;
};

/**
 * Duplicate a prompt (admin)
 */
export const duplicatePrompt = async (id, options = {}) => {
  const response = await api.post(`/prompts/admin/duplicate/${id}`, options);
  return response.data;
};

/**
 * Bulk create/update prompts (admin)
 */
export const bulkPrompts = async (prompts) => {
  const response = await api.post('/prompts/admin/bulk', { prompts });
  return response.data;
};

export default {
  getPromptTypes,
  previewPrompt,
  getPrompts,
  getPrompt,
  createPrompt,
  updatePrompt,
  deletePrompt,
  duplicatePrompt,
  bulkPrompts
};
